import { createTheme } from "@mui/material/styles";

export const theme=(mode:Boolean) => createTheme(!mode?{
  palette: {
    background: {
      default: "#E1E2E2",
      paper:'#fdf9f3',
    },
    info: {
      main: "#000",
      dark:'#fff'
    },
    primary: {
      main: "#00458B",
    },
    secondary: {
      main: "#3FD2C7",
    },
  },
  typography: {
    fontFamily: `'Changa', sans-serif`,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
}:{
  palette: {
    background: {
      default: "#1D2228",
      paper:'#181818',
    },
    info: {
      main:'#fff',
      dark: "#000",

    },
    primary: {
      main: "#1BA098",
    },
    secondary: {
      main: "#000",
    },
  },
  typography: {
    fontFamily: `'Changa', sans-serif`,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});
